export class FilterBaseModel {
    cols: string;
    searchText = '';
    pageNumber = 1;
    pageSize = 20;
    pageCode = '';
    isHot?= null;

}
